import { frequencySliderMaxValue, frequencySliderMinValue } from '@/constants/forecaster';
import { useCallback } from 'react';
import { useFormContext, useWatch } from 'react-hook-form';
import EstimationSlider from '../EstimationSlider';
import EstimationSwitch from '../EstimationSwitch';

const Frequency = () => {
  const { control, setValue } = useFormContext();
  const isFrequencyCapToggled = useWatch({ control, name: 'frequencyCapEnabled' });
  const frequencyCapPerDay = useWatch({ control, name: 'frequencyCapPerDay' });

  const enableFrequencyCap = useCallback(
    e => {
      setValue('frequencyCapEnabled', e.target.checked);
      if (e.target.checked) {
        setValue('frequencyCapPerDay', 1);
      } else {
        setValue('frequencyCapPerDay', null);
      }
    },
    [setValue],
  );

  const changeFrequencyCap = useCallback(
    (_, value) => {
      setValue('frequencyCapPerDay', value);
    },
    [setValue],
  );

  return (
    <>
      <EstimationSwitch
        title='Daily Frequency Cap'
        enabled={!!isFrequencyCapToggled}
        handleChange={enableFrequencyCap}
      />
      {isFrequencyCapToggled && (
        <EstimationSlider
          handleChange={changeFrequencyCap}
          value={frequencyCapPerDay}
          minValue={frequencySliderMinValue}
          maxValue={frequencySliderMaxValue}
        />
      )}
    </>
  );
};

export default Frequency;
